<nz-modal
  [nzVisible]="true"
  [nzFooter]="null"
  (nzOnCancel)="onWizardCancel()"
  [nzTitle]="i18n.langString('add_documentation')"
  [nzCloseIcon]="'icons:exit'"
  [nzContent]="modalContent"
>
  <ng-template #modalContent>
    @if (isLoading()) {
      <app-spinner [black]="true"></app-spinner>
    }
    <!-- START STEP -->
    @if (!isLoading() && step() === "start") {
      <div class="card-layer docu-card-layer docu-card-layer-wide">
        @if (documentationError()) {
          <span class="access-error">
            {{ i18n.langString("documentation_access_error") }}
          </span>
        }
        <h3 class="docAdjustmentMargin docAdjustmentCenter">
          {{ i18n.langString("pick_something_that_applies") }}
        </h3>

        <div
          class="more-info-group body-bold"
          [class.preselected]="radioValue() !== 0"
        >
          <button
            class="documentation-info"
            [class.selected]="radioValue() === 1"
            (click)="radioValue.set(1); setDocumentationType('repair')"
          >
            <i nz-icon nzType="icons:tool" class="svg-icon mini-icon"></i>
            <label>{{ i18n.langString("needs_to_be_repaired") }}</label>
          </button>

          <button
            class="documentation-info"
            [class.selected]="radioValue() === 2"
            (click)="radioValue.set(2); setDocumentationType('fixed')"
          >
            <i nz-icon nzType="icons:fixed" class="svg-icon mini-icon"></i>
            <label>{{ i18n.langString("problem_fixed") }}</label>
          </button>

          <button
            class="documentation-info"
            [class.selected]="radioValue() === 3"
            (click)="radioValue.set(3); setDocumentationType('false_alert')"
          >
            <i
              nz-icon
              nzType="icons:status-exclamation-triangle"
              class="svg-icon mini-icon"
            ></i>
            <label>{{ i18n.langString("false_alert") }}</label>
          </button>

          <button
            class="documentation-info"
            [class.selected]="radioValue() === 4"
            (click)="radioValue.set(4); setDocumentationType('other')"
          >
            <i nz-icon nzType="icons:others" class="svg-icon mini-icon"></i>
            <label>{{ i18n.langString("others") }}</label>
          </button>
        </div>
      </div>
    }

    <!-- ADD STEP -->
    @if (!isLoading() && step() === "add") {
      <div class="card-layer docu-card-layer">
        <div
          class="docMarginAdjustment"
          [class.mobile-Adjustment]="!isDesktop()"
          id="documentation-selected-choice"
        >
          @if (documentation().documentationType === "repair") {
            <app-asset-nav-button
              [asset]="null"
              (clickEvent)="step.set('start')"
              svg_icon="icons:tool"
              [blackCoral]="true"
              svg_icon_right="icons:edit"
            >
              {{ i18n.langString("needs_to_be_repaired") }}
            </app-asset-nav-button>
          }
          @if (documentation().documentationType === "fixed") {
            <app-asset-nav-button
              [asset]="null"
              (clickEvent)="step.set('start')"
              svg_icon="icons:fixed"
              [blackCoral]="true"
              svg_icon_right="icons:edit"
            >
              {{ i18n.langString("problem_fixed") }}
            </app-asset-nav-button>
          }
          @if (documentation().documentationType === "false_alert") {
            <app-asset-nav-button
              [asset]="null"
              (clickEvent)="step.set('start')"
              svg_icon="icons:status-exclamation-triangle"
              [blackCoral]="true"
              svg_icon_right="icons:edit"
            >
              {{ i18n.langString("false_alert") }}
            </app-asset-nav-button>
          }
          @if (documentation().documentationType === "other") {
            <app-asset-nav-button
              [asset]="null"
              (clickEvent)="step.set('start')"
              svg_icon="icons:others"
              [blackCoral]="true"
              svg_icon_right="icons:edit"
            >
              {{ i18n.langString("others") }}
            </app-asset-nav-button>
          }
        </div>

        <h3 class="docAdjustmentCenter">
          {{ i18n.langString("please_add_more_information") }}
        </h3>

        <app-docu-item
          [variant]="'text'"
          [svg_icon]="'icons:note'"
          (clickEvent)="step.set('note')"
          (documentationError)="documentationError.set($event)"
        >
          {{ i18n.langString("add_note") }}
        </app-docu-item>

        <app-docu-item
          [variant]="'image'"
          [svg_icon]="'icons:camera'"
          [content]="documentation().images"
          [documentationId]="documentation().documentationId"
          (documentationError)="documentationError.set($event)"
        >
          {{
            !isDesktop()
              ? i18n.langString("take_or_upload_a_photo")
              : i18n.langString("upload_a_photo")
          }}
        </app-docu-item>

        <app-docu-item
          [variant]="'file'"
          [svg_icon]="'icons:file'"
          [content]="documentation().files"
          [documentationId]="documentation().documentationId"
          (documentationError)="documentationError.set($event)"
        >
          {{ i18n.langString("add_file") }}
        </app-docu-item>

        <div
          class="buttonwrapper buttonwrapper_bottom"
          [class.mobile-Adjustment]="!isDesktop()"
          [class.desktop-Adjustment]="isDesktop()"
        >
          <app-nav-button
            [primary]="true"
            (clickEvent)="save()"
            svgIcon="icons:save"
          >
            {{ i18n.langString("save_documentation") }}
          </app-nav-button>
        </div>
      </div>
    }

    <!-- NOTE STEP -->
    @if (!isLoading() && step() === "note") {
      <div class="card-layer docu-card-layer add-note">
        <h3>
          <i nz-icon nzType="icons:note" class="svg-icon mini-icon"></i>
          {{ i18n.langString("add_note") }}
        </h3>

        <textarea
          id="note-input"
          name="note-input"
          cols="40"
          rows="5"
          class="regular"
          placeholder="Please add a description"
          [value]="documentation().note"
          (input)="onNoteInput($event)"
        ></textarea>

        <div class="buttonwrapper buttonwrapper_bottom">
          <app-nav-button
            [primary]="true"
            svgIcon="icons:note"
            [disabled]="false"
            (clickEvent)="setNote()"
          >
            {{ i18n.langString("save_note") }}
          </app-nav-button>
        </div>
      </div>
    }
  </ng-template>
</nz-modal>
